import { useEffect, useState } from "react";
import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";
import { getLocale } from "react-i18nify";

import MuiDialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";

import Button from "src/components/core/Button";

import { UseUpload } from "src/context/UploadProductContext";

const Dialog = muiStyled(MuiDialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 32,
  },
  "& .MuiDialogContent-root": {
    maxHeight: "500px",
    border: 0,
  },
  "& .MuiDialogActions-root": {
    justifyContent: "space-between",
  },
}));

const WrapperTextfield = styled.div`
  width: 100%;

  .TextField-without-border-radius fieldset {
    border-radius: 16px;
    // text-align: center;
    // background: #fff;
  }
  .TextField-without-border-radius-amount fieldset {
    border-radius: 16px;
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .MuiAutocomplete-root {
    /* margin: ${({ item }) => (item ? "0" : "24px 0")}; */
    margin: 0;
  }
  .MuiOutlinedInput-input {
    background: #fff;
    /* border-radius: 24px; */
    padding: 16px;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 16px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 16px;
  }

  .MuiTextField-root {
    border-radius: 24px;
  }
  .MuiOutlinedInput-root {
    border-radius: 16px;
  }
  .MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
    padding: 7.5px 0;
  }
`;

const BrandDialog = ({ value, isOpen = false, onClose }) => {
  const { onChangeUpload } = UseUpload();
  const [text, setText] = useState("");

  useEffect(() => {
    setText(value.name);
  }, [value]);

  const addNewBrand = () => {
    onChangeUpload(null, `brand`, { name: text });
    onClose();
  };

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: 350,
          },
        },
      }}
    >
      <DialogTitle sx={{ p: 3, textAlign: "center" }}>
        Add new brand
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        <WrapperTextfield>
          <TextField
            variant="outlined"
            fullWidth
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
        </WrapperTextfield>
      </DialogContent>

      <DialogActions sx={{ px: 3, pt:0, pb: 3 }}>
        <Button
          variant="outlined"
          size="large"
          onClick={() => onClose()}
          sx={{ minWidth: 140, borderRadius: 4, py: 1.5 }}
        >
          {getLocale() === "th" ? "ยกเลิก" : "Cancel"}
        </Button>

        <Button
          variant="contained"
          size="large"
          onClick={() => addNewBrand()}
          sx={{ minWidth: 140, borderRadius: 4, py: 1.5 }}
        >
          {getLocale() === "th" ? "ยืนยัน" : "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BrandDialog;
